export default "__VITE_ASSET__Bt4tQNU0__"